import * as React from 'react'
import {
  List,
  Datagrid,
  Create,
  SimpleForm,
  TextField,
  EditButton,
  TextInput,
  SelectInput,
  ReferenceArrayInput,
  SelectArrayInput,
  ChipField,
  SingleFieldList,
  ReferenceArrayField,
  SelectField,
  ImageInput,
  ImageField,
  NumberInput,
  BooleanInput
} from 'react-admin'
import StarIcon from '@material-ui/icons/Star'

export const ProductIcon = StarIcon

export const ProductList = (props) => (
  <List {...props}>
    <Datagrid>
      <TextField label='Título' source='title' />
      <SelectField
        label='Gênero'
        source='gender' choices={[
          { id: 'M', name: 'Masculino' },
          { id: 'F', name: 'Feminino' },
          { id: 'U', name: 'Unisex' }
        ]}
      />
      <ReferenceArrayField
        label='Categorias'
        reference='categories'
        source='categories'
      >
        <SingleFieldList>
          <ChipField source='title' />
        </SingleFieldList>
      </ReferenceArrayField>

      <ReferenceArrayField
        label='Tamanhos'
        reference='sizes'
        source='sizes'
      >
        <SingleFieldList>
          <ChipField source='name' />
        </SingleFieldList>
      </ReferenceArrayField>

      <ReferenceArrayField
        label='Cores'
        reference='colors'
        source='colors'
      >
        <SingleFieldList>
          <ChipField source='name' />
        </SingleFieldList>
      </ReferenceArrayField>

      <EditButton basePath='/products' />
    </Datagrid>
  </List>
)

export { default as ProductEdit } from './ProductEdit'

export const ProductCreate = (props) => (
  <Create title='Criar novo produto' {...props}>
    <SimpleForm>
      <BooleanInput label='Ativo' source='active' />
      <TextInput label='Chave' source='id' />
      <TextInput label='Título' source='title' />
      <TextInput label='Descrição' source='description' multiline />
      <NumberInput label='Preço' source='price' min={0} max={999} step={0.10} />
      <SelectInput
        label='Gênero'
        source='gender'
        choices={[
          { id: 'M', name: 'Masculino' },
          { id: 'F', name: 'Feminino' },
          { id: 'U', name: 'Unisex' }
        ]}
      />
      <ReferenceArrayInput
        reference='categories'
        source='categories'
      >
        <SelectArrayInput
          label='Categorias'
          optionText='title'
        />
      </ReferenceArrayInput>
      <ReferenceArrayInput reference='sizes' source='sizes'>
        <SelectArrayInput label='Tamanhos'>
          <ChipField source='name' />
        </SelectArrayInput>
      </ReferenceArrayInput>
      <ReferenceArrayInput reference='colors' source='colors'>
        <SelectArrayInput label='Cores'>
          <ChipField source='name' />
        </SelectArrayInput>
      </ReferenceArrayInput>
      <ReferenceArrayInput reference='tags' source='tags'>
        <SelectArrayInput label='Tags'>
          <ChipField source='name' />
        </SelectArrayInput>
      </ReferenceArrayInput>
      <ImageInput
        multiple
        source='catalog_image'
        label='Imagem do catálogo'
        accept='image/*'
      >
        <ImageField source='src' title='title' />
      </ImageInput>
    </SimpleForm>
  </Create>
)
